import { render, staticRenderFns } from "./MunicipalitySelectionList.vue?vue&type=template&id=48d7d16a&scoped=true&"
import script from "./MunicipalitySelectionList.vue?vue&type=script&lang=ts&"
export * from "./MunicipalitySelectionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d7d16a",
  null
  
)

export default component.exports